module.exports = __webpack_public_path__ + "static/capsule-preview-champlain-3.56b16e99.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-champlain-3.png
// module id = 893
// module chunks = 168707334958949